import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { Typography } from '@mui/material';
import { fetchServices } from '../slice/carriersSlice';
import { useParams } from 'react-router-dom';
import { filter } from '../utils/filter';
import { Search } from '../Components/Search';
import Loader from '../Components/Loader';
import { getCarrierDetailsColumns, getCarrierDetailsRows, calculateTotalsForCarrierDetails } from '../utils/dashbaord';

export default function CarrierDetail() {
  const dispatch = useDispatch();
  const { carrierId } = useParams();

  const [searchQuery, setSearchQuery] = useState('');
  const { services = [], loading = false } = useSelector((state) => state.carriers || {});
  const userRole = useSelector((state) => state.user.userRole);

  const service = services.find(service =>
    carrierId.toLowerCase() === service.carrierName?.toLowerCase()
  );

  const { carrierDetails } = service || {}

  useEffect(() => {
    dispatch(fetchServices());
  }, [dispatch]);

  const searchColumns = ["name", "trackingNumber", "customerPrice", "revenue", "profit", "shipmentDate"]
  const columns = getCarrierDetailsColumns(userRole);
  const rows = getCarrierDetailsRows(carrierDetails, userRole);

  const filteredRows = filter(rows, searchQuery, searchColumns);
  const sortedRows = [...filteredRows]
    .sort((a, b) => new Date(b.createdAtRaw) - new Date(a.createdAtRaw))
    .map((row, index) => ({ ...row, id: index + 1 }));
  const finalRows = calculateTotalsForCarrierDetails(sortedRows);

  if (loading) return <Loader />;

  return (
    <Box sx={{ width: '100%' }}>
      <div className="shadow-md p-1 bg-white rounded-xl border border-gray-100 mb-3 mt-3">
        <Typography sx={{ fontWeight: 'bold', fontSize: '1.8rem', pl: 1 }}>
          {carrierId}
        </Typography>
      </div>
      <Search
        setSearchQuery={setSearchQuery}
        searchQuery={searchQuery}
        searchBy="Carrier Version, Tracking Number, Customer Price, Revenue, Profit, Shipment Date"
      />
      <Box
        sx={{
          height: 'calc(100vh - 155px)',
          width: '100%',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
          borderRadius: 2,
          backgroundColor: 'white',
          overflow: 'hidden',
          '& .MuiDataGrid-cell': { fontSize: '0.8rem' },
          '& .MuiDataGrid-columnHeader': { fontSize: '0.9rem' }
        }}
      >
        <DataGrid
          rows={finalRows ? finalRows : []}
          columns={columns}
          getRowClassName={(params) =>
            String(params.id).startsWith('Total') || String(params.id) === 'Overall-Total'
              ? 'bg-gray-200 font-bold'
              : ''
          }

          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 8
              }
            }
          }}
          pageSizeOptions={[5]}
        />
      </Box>
    </Box>
  );
};